import { Category, PageInfo, Post, } from 'generated-graphql';
import { CATEGORIES } from 'gql/categories';
import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global';
import { GetServerSideProps } from 'next';
import React from 'react';
import get from 'lodash/get';
import { getPosts } from 'gql/posts';
import ResourcesPage from '@/components/ResourcesPage/ResourcesPage';
import { cache } from '@/pages/_app';

const ResourceList = ({
  pageData,
  categories,
  c,
  pageInfo,
  featured
}: {
  pageData: Post[];
  categories: Category[];
  c: Category;
  pageInfo: PageInfo,
  featured: Post[];
}) => {

  return (
    <ResourcesPage pageData={pageData} categories={categories} c={c} pageInfo={pageInfo} featured={featured} />
  );
};

export default ResourceList;

// Server-side for pagination
export const getServerSideProps: GetServerSideProps<{ time: string }> = async (context) => {
  const { query, res } = context;
  const apolloClient = initializeApollo();

  const slug = `resource/${query.slug}`;
  const cacheKey = slug;

  if (query['purge-cache'] === 'true') {
    console.log('-----> CACHE [DELETE]: cacheKey', cacheKey);
    cache.delete(cacheKey);
  }

  // Check if we have cached the page
  const cachedValue: any = cache.get(cacheKey);
  if (cachedValue) {
    // Retrieve the page from cache

    console.log(
      '-----> CACHE [HIT]: cacheKey',
      cacheKey,
      // cachedValue?.props?.pageBlocks,
    );
    return JSON.parse(cachedValue);
  }


  const slugProps = query?.slug as string[];
  const v = slugProps[0];
  let from = '';
  if (slugProps[1]) {
    from = slugProps[1];
  }

  const categoriesQuery = await apolloClient.query({
    query: CATEGORIES,
    variables: { names: ['What we do', 'Series'] },
  });

  const categories = get(categoriesQuery, 'data.categories.nodes', []) as Category[];

  const categoryLabels: string[] = [];

  let c = null;
  categories.forEach((mainCat) => {
    mainCat.children?.nodes.forEach((cat) => {
      if (cat.slug === v) {
        c = cat;
        categoryLabels.push(cat.name || '');
      }
    })
  });


  const results = await apolloClient.query({
    query: getPosts(
      categoryLabels,
    ), variables: {
      after: from,
      first: 11,
    }
  });

  const featured = await apolloClient.query({
    query: getPosts(
      ["Featured", ...categoryLabels]
    ), variables: {
      first: 3,
    }
  });


  const pageProps = {
    pageInfo: results.data?.posts?.pageInfo,
    pageData: results.data?.posts?.nodes || [],
    categories,
    featured: featured.data?.posts?.nodes || [],
    c,
  };

  const retProps = await getGlobalData(pageProps, apolloClient);

  if (process.env.IS_PRODUCTION === 'true') {
    cache.set(cacheKey, JSON.stringify(retProps));
    console.log('-----> CACHE [SET]: cacheKey', cacheKey);
  }

  return retProps;
};
